import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-220389d7"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "big-title"
}, "公司介绍", -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createTextVNode("广州小圈科技有限公司，是一家移动互联网公司。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 小圈app是公司旗下主营一款基于地理位置的移动社交产品。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 核心功能真人认证，通过AI智能识别+人工审核的机制，保障用户照片真实。")], -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "big-title"
}, "联系我们", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "content"
}, "xqy888vip@163.com", -1));

const _hoisted_5 = [_hoisted_1, _hoisted_2, _hoisted_3, _hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", {
    class: "hello",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => $setup.hideTip && $setup.hideTip(...args))
  }, _hoisted_5, 512), [[_vShow, $setup.show]]), _withDirectives(_createElementVNode("div", {
    class: "back",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    (...args) => $setup.hideTip && $setup.hideTip(...args))
  }, null, 512), [[_vShow, $setup.show]])], 64);
}